if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.priceWrapper = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.submitButton = this.querySelector(`#StickySubmitButton-${this.sectionId}`);
      }

      connectedCallback() {
        this.isTargetVisible = false;
        this.isAtBottom = false;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.setHeightProperty = this.setHeightProperty.bind(this);
        this.setHeightProperty();
        this.mobileQuery.addEventListener('change', this.setHeightProperty);

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        this.observeTargetButton();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.onVariantChange(event.data);
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileQuery.removeEventListener('change', this.setHeightProperty);
        window.removeEventListener('scroll', this.onScroll);
        this.variantChangeUnsubscriber?.();
      }

      setHeightProperty() {
        document.documentElement.style.setProperty('--sticky-cart-height', `${this.offsetHeight}px`);
      }

      updateVisibility() {
        const wasHidden = this.hidden;
        this.hidden = this.isTargetVisible || (!this.mobileQuery.matches && this.isAtBottom);
        // the bar has no height while hidden: measure it once it shows so the page padding matches
        if (wasHidden && !this.hidden) this.setHeightProperty();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1;
          this.updateVisibility();
          this.ticking = false;
        });
      }

      observeTargetButton() {
        const targetId = this.dataset.targetId;
        const target = targetId && document.getElementById(targetId);
        if (!target) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            this.isTargetVisible = entries[0].isIntersecting;
            this.updateVisibility();
          },
          { rootMargin: '0px 0px -1px 0px' }
        );
        this.observer.observe(target);
      }


      onVariantChange({ html, variant }) {
        if (this.priceWrapper) {
          const sourcePrice = html.getElementById(`price-${this.sectionId}`);
          if (sourcePrice) this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        if (this.submitButton) {
          const sourceButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          const disabled = !variant || (sourceButton?.hasAttribute('disabled') ?? true);
          this.submitButton.toggleAttribute('disabled', disabled);
          const label = this.submitButton.querySelector('span');
          if (label && sourceButton) {
            label.textContent = sourceButton.querySelector('span')?.textContent.trim() ?? label.textContent;
          }
        }
      }
    }
  );
}